// Arquivo: GerenciadorDeRotas.js
import React, { useState } from 'react';
import { Card, CardBody, CardHeader, Input, Table, Button, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';

const GerenciadorDeRotas = ({ nodes, edges, onDeleteNode, onDeleteEdge }) => {
    const [activeTab, setActiveTab] = useState('1');
    const [filtro, setFiltro] = useState('');

    const destinos = nodes.filter(n => n.type === 'destination' && (n.description || '').toLowerCase().includes(filtro.toLowerCase()));
    const pontos = nodes.filter(n => n.type === 'intersection' && n.id.toLowerCase().includes(filtro.toLowerCase()));
    const caminhos = edges.filter(e => (e.source + e.target).toLowerCase().includes(filtro.toLowerCase()));

    return (
        <Card style={{ marginTop: '1rem' }}>
            <CardHeader>
                <Nav tabs className="nav-tabs-custom">
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab === '1' })} onClick={() => setActiveTab('1')}>
                            Destinos ({destinos.length})
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab === '2' })} onClick={() => setActiveTab('2')}>
                            Pontos de Rota ({pontos.length})
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab === '3' })} onClick={() => setActiveTab('3')}>
                            Caminhos ({caminhos.length})
                        </NavLink>
                    </NavItem>
                </Nav>
            </CardHeader>
            <CardBody>
                <Input
                    type="text"
                    placeholder="Filtrar por nome ou ID..."
                    value={filtro}
                    onChange={(e) => setFiltro(e.target.value)}
                    style={{ marginBottom: '1rem' }}
                />
                <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        <Table striped size="sm">
                            <thead><tr><th>Nome do Destino</th><th>Ações</th></tr></thead>
                            <tbody>
                                {destinos.map(node => (
                                    <tr key={node.id}>
                                        <td>{node.description || '(Sem nome)'}</td>
                                       
                                        <td><Button color="danger" size="sm" onClick={() => onDeleteNode(node.id)}>Excluir</Button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </TabPane>
                    <TabPane tabId="2">
                        <Table striped size="sm">
                            <thead><tr><th>ID do Ponto</th><th>Ações</th></tr></thead>
                            <tbody>
                                {pontos.map(node => (
                                    <tr key={node.id}>
                                        <td>{node.description}</td>
                                        <td><Button color="danger" size="sm" onClick={() => onDeleteNode(node.id)}>Excluir</Button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </TabPane>
                    <TabPane tabId="3">
                         <Table striped size="sm">
                            <thead><tr><th>De (ID)</th><th>Para (ID)</th><th>Ações</th></tr></thead>
                            <tbody>
                                {caminhos.map(edge => (
                                    <tr key={edge.id}>
                                        <td>{edge.sourceName ?? edge.source}</td>
                                        <td>{edge.targetName ?? edge.target}</td>
                                        <td><Button color="danger" size="sm" onClick={() => onDeleteEdge(edge.id)}>Excluir</Button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </TabPane>
                </TabContent>
            </CardBody>
        </Card>
    );
};

export default GerenciadorDeRotas;
